import image from '../../assets/homePaginatorFirstOne.png';
import twitter from '../../assets/paginationtwitter.svg';
import facebook from '../../assets/paginationfacebook.png';
import instagram from '../../assets/paginationinsta.svg';
const people = [
 {
  id: 1,
  image: image,
  desc: 'Zigma started their land mininga cleared a mass amount of plastic ',
  icon: twitter,
  handle: '#ZigmaEPR',
 },
 {
  id: 2,
  image: image,
  desc: 'Zigma started their land mininga cleared a mass amount of plastic ',
  icon: facebook,
  handle: 'EPR FB',
 },
 {
  id: 3,
  image: image,
  desc: 'Zigma started their land mininga cleared a mass amount of plastic ',
  icon: instagram,
  handle: '_EPR_Zigma',
 },
 {
  id: 4,
  image: image,
  desc: 'Zigma started their land mininga cleared a mass amount of plastic ',
  icon: twitter,
  handle: '#ZigmaEPR',
 },
 {
  id: 5,
  image: image,
  desc: 'Zigma started their land mininga cleared a mass amount of plastic ',
  icon: facebook,
  handle: 'EPR FB',
 },
 {
  id: 6,
  image: image,
  desc: 'Zigma started their land mininga cleared a mass amount of plastic ',
  icon: instagram,
  handle: '_EPR_Zigma',
 },
];

export default people;
